import { ListItemText } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { createStyles, makeStyles, Theme } from '../../../themes/ThemeProvider'
import Checkbox from '../../controls/Checkbox'
import TextField, { TextFieldProps as Props } from '../Input'

export type MultiSelectOption = {
  value: string
  label: string
}

export type MultiSelectOptions = MultiSelectOption[]

type ReactHookMultiSelectProps = {
  name: string
  options: MultiSelectOptions,
  formContext?: any
}

export type FormMultiSelectProps = Props & ReactHookMultiSelectProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2.5)
    },
    MuiFormHelperTextContained: {
      marginLeft: 0,
      position: 'absolute',
      bottom: theme.spacing(-2.5)
    }
  })
)

export const FormMultiSelect: React.FC<FormMultiSelectProps> = (props) => {
  const classes = useStyles(props)
  const { formContext, name, label, options, defaultValue, ...rest } = props

  const formContextLocal = useFormContext()
  const { control, errors } = formContext || formContextLocal

  const formHelperTextProps = {
    classes: {
      contained: classes.MuiFormHelperTextContained
    }
  }

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue ?? []}
        render={({ onChange, value }) => {
          return (
            <TextField
              select
              fullWidth
              label={label ? label : undefined}
              placeholder={label ? `Enter ${label}` : undefined}
              SelectProps={{
                value,
                SelectDisplayProps: { id: `${name}SelectArea` },
                multiple: true,
                renderValue: (selected: any) =>
                  (selected as string[]).join(', '),
                onChange
              }}
              helperText={errors[`${name}`]?.message}
              error={!!errors[`${name}`]}
              FormHelperTextProps={formHelperTextProps}
              className={classes.root}
              inputProps={{ 'data-testid': name }}
              {...rest}
            >
              {options.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  <Checkbox checked={value.includes(item.value)} />
                  <ListItemText primary={item.label} />
                </MenuItem>
              ))}
            </TextField>
          )
        }}
      />
    </>
  )
}
